// カウントアップアニメーション
(function () {
  function animateCountUp(el, target, duration, suffix = '', originalNumStr = '') {
    let start = 0;
    let startTime = null;

    // スケール用ラッパーを付与
    if (!el.classList.contains('countup-scale')) {
      el.classList.add('countup-scale');
    }
    function format(num) {
      // 元の文字列に小数点があれば、小数点表示。なければカンマ付き整数。
      if (originalNumStr.includes('.')) {
        return num.toFixed(1);
      }
      return Math.floor(num).toLocaleString();
    }
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const value = start + (target - start) * progress;
      el.textContent = format(value) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = format(target) + suffix;
        // スケールアニメーション
        el.classList.add('countup-scale--active');
        setTimeout(function(){
          el.classList.remove('countup-scale--active');
        }, 220);
      }
    }
    requestAnimationFrame(step);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Intersection Observerで一度だけカウントアップ
    function observeAndCountUp(targets, handler) {
      if (!('IntersectionObserver' in window)) {
        // 古いブラウザは即時実行
        targets.forEach(handler);
        return;
      }
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            handler(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      targets.forEach(el => observer.observe(el));
    }

    // .realreport-card__value
    observeAndCountUp(
      Array.from(document.querySelectorAll('.realreport-card__value')),
      function (el) {
        const unitEl = el.querySelector('.realreport-card__unit');
        const originalNumStr = el.textContent.replace(unitEl ? unitEl.textContent : '', '').trim();
        const targetNum = parseFloat(originalNumStr.replace(/,/g, ''));
        const suffix = unitEl ? unitEl.textContent : '';

        // 数字部分をspanで囲み、アニメーション対象を明確にする
        el.innerHTML = `<span class="countup-target">${originalNumStr}</span>`;
        if(suffix) {
          el.innerHTML += `<span class="realreport-card__unit">${suffix}</span>`;
        }
        const countupTarget = el.querySelector('.countup-target');

        animateCountUp(countupTarget, targetNum, 1200, '', originalNumStr);
      }
    );

    // .realreport-card__note の「:」以降の数字だけカウントアップ（.no-countup は除外）
    document.querySelectorAll('.realreport-card__note:not(.no-countup)')
      .forEach(function (el) {
      const match = el.textContent.match(/^(.*?)([：:])\s*([\d\.,]+)/);
      if (match) {
        const prefix = match[1] + match[2] + ' ';
        const numStr = match[3];
        const num = parseFloat(numStr.replace(/,/g, ''));
        // prefixはそのまま、数字部分だけspanで囲む
        el.innerHTML = prefix + '<span class="realreport-card__note-count">' + numStr + '</span>';
        // カウントアニメーションはspanが画面内に入ったタイミングで
        const span = el.querySelector('.realreport-card__note-count');
        observeAndCountUp([span], function(target){
          animateCountUp(target, num, 1000, '', numStr);
        });
      }
    });
  });
})();
